import { loadStripe } from '@stripe/stripe-js'

let stripePromise;
export const getStripe = (publicKey) => {
    if (!stripePromise) {
        stripePromise = loadStripe(publicKey)
    }
    return stripePromise
}
